// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getPreviousBreakpoint from "@toolkit/Framework/Common/Utilities/getPreviousBreakpoint";
import { focusStyles, iconColorStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import getColor from "@insite/mobius/utilities/getColor";
/* Store Custom Code - End */

export const headerMobileSelector = () => css`
    ${({ theme }) => breakpoint(getPreviousBreakpoint(theme.design.header.breakpoint, theme), "down")}
`;

export const headerDesktopSelector = () => css`
    ${({ theme }) => breakpoint(theme.design.header.breakpoint)}
`;

export const headerHideForDesktopStyles = () => css`
    ${headerDesktopSelector()} {
        display: none;
    }
`;

export const headerHideForMobileStyles = () => css`
    ${headerMobileSelector()} {
        display: none;
    }
`;

export const headerIconStyles = () => {
    const transition = transitionHoverStyles("color", "border-color"); // Store Custom Code

    return css`
        ${focusStyles(true)}
        ${x => breakpointValues(x.theme.design.header.iconButton.padding, "padding")}
        transition: ${transition};

        ${IconWrapper} {
            ${iconColorStyles("header.accent", transition)}
        }

        &:hover,
        &:active,
        &[aria-expanded="true"] {
            ${IconWrapper} {
                ${iconColorStyles("header.accentHover", transition)}
            }
        }

        /* Store Custom Code - Start */
        ${headerDesktopSelector()} {
            > ${IconWrapper} {
                box-sizing: content-box;
                padding: ${pxToRem(10)};
                border: ${pxToRem(2)} solid transparent;
                background-color: ${getColor("common.accent")};
                border-radius: 50%;

                svg {
                    margin: 0;
                }
            }

            &:hover,
            &:active,
            &[aria-expanded="true"] {
                > ${IconWrapper} {
                    background-color: ${getColor("primary.lightest")};
                }
            }

            &[aria-expanded="true"] {
                > ${IconWrapper} {
                    border-color: ${getColor("header.accentHover")};
                }
            }
        }
        /* Store Custom Code - End */
    `;
};
